var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccord15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 180,
    viewBox: "0 0 202 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7906 76.0345V47.1746H31.5392C14.1486 47.1746 0 61.3179 0 78.7031V173.091C0 175.49 1.44547 177.652 3.66211 178.57C4.39612 178.874 5.1669 179.021 5.93096 179.021C7.4749 179.021 8.99234 178.419 10.127 177.284L32.2171 155.202H123.29C140.681 155.202 154.829 141.058 154.829 123.673V119.423H79.1941C55.2611 119.423 35.7906 99.9594 35.7906 76.0345Z",
    fill: "#F1EEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170.462 0H78.7112C61.3205 0 47.1719 14.1434 47.1719 31.5285V76.4987C47.1719 93.8838 61.3205 108.027 78.7112 108.027H169.784L191.874 130.109C193.009 131.244 194.526 131.847 196.07 131.847C196.834 131.847 197.605 131.699 198.339 131.395C200.555 130.477 202.001 128.315 202.001 125.916V31.5285C202.001 14.1434 187.853 0 170.462 0ZM88.8453 59.499C85.5197 59.499 83.0571 56.7818 82.9131 53.5688C82.7696 50.3662 85.7424 47.6387 88.8453 47.6387C92.1709 47.6387 94.6335 50.3559 94.7775 53.5688C94.921 56.7715 91.9482 59.499 88.8453 59.499ZM124.587 59.499C121.261 59.499 118.798 56.7818 118.654 53.5688C118.511 50.3662 121.484 47.6387 124.587 47.6387C127.912 47.6387 130.375 50.3559 130.519 53.5688C130.662 56.7715 127.689 59.499 124.587 59.499ZM160.328 59.499C157.002 59.499 154.54 56.7818 154.396 53.5688C154.252 50.3662 157.225 47.6387 160.328 47.6387C163.653 47.6387 166.116 50.3559 166.26 53.5688C166.404 56.7715 163.431 59.499 160.328 59.499Z",
    fill: "#F1EEF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccord15);
export default __webpack_public_path__ + "static/media/accord_15.15b352f43ca6bb9df1ae3073edb3ceec.svg";
export { ForwardRef as ReactComponent };